import { OrderGenericProfileSettings } from "./order-profile-settings-base";
import { YoutubeChannel } from "./youtube-channel";

export interface TranskodeYoutubeChannelDelivery extends OrderGenericProfileSettings {
  channels: YoutubeChannel[] | null;
  customId: string | null;
  title: string | null;
  filename: string | null;
  channel: string | null;
  movieLabels: string[] | null;
  description: string | null;
  keywords: string[] | null;
  spokenLanguage: string | null;
  captionFile: string | null;
  captionLanguage: string | null;
  category: TranskodeYoutubeChannelDeliveryCategory;
  privacy: TranskodeYoutubeChannelDeliveryPrivacy;
  notifySubscribers: boolean;
  startTime: string | null;
  endTime: string | null;
  customThumbnail: string | null;
  thumbnailFileId: number | null;
  territoriesCodes: string[] | null;
  blockOutsideOwnership: boolean;
  usagePolicy: TranskodeYoutubeChannelDeliveryPolicy;
  matchPolicy: TranskodeYoutubeChannelDeliveryPolicy;
  enableContentId: boolean;
  referenceExclusions: string[] | null;
  adTypes: string[] | null;
  adBreakTimes: string | null;
  playlistIds: string[] | null;
  isMadeForKids: boolean;
  preRoll: boolean;
  postRoll: boolean;
}

export enum TranskodeYoutubeChannelDeliveryCategory {
  AutosAndVehicles = "AutosAndVehicles",
  Comedy = "Comedy",
  Education = "Education",
  Entertainment = "Entertainment",
  FilmAndAnimation = "FilmAndAnimation",
  Gaming = "Gaming",
  HowtoAndStyle = "HowtoAndStyle",
  Music = "Music",
  NewsAndPolitics = "NewsAndPolitics",
  NonprofitsAndActivism = "NonprofitsAndActivism",
  PeopleAndBlogs = "PeopleAndBlogs",
  PetsAndAnimals = "PetsAndAnimals",
  ScienceAndTechnology = "ScienceAndTechnology",
  Sports = "Sports",
  TravelAndEvents = "TravelAndEvents",
}

export enum TranskodeYoutubeChannelDeliveryPrivacy {
  Unlisted = "Unlisted",
  Private = "Private",
  Public = "Public",
}

export enum TranskodeYoutubeChannelDeliveryPolicy {
  None = "None",
  MonetizeInAllCountries = "MonetizeInAllCountries",
  TrackInAllCountries = "TrackInAllCountries",
  BlockInAllCountries = "BlockInAllCountries",
}
